// 客服：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 客服界面
export const ui = Object.freeze({
  "agentServiceUI.answerElapsed": "总用时 {duration}",
  "agentServiceUI.answerSeconds": "{seconds}秒",
  "agentServiceUI.answerMinutes": "{minutes}分{seconds}秒",
  "agentServiceUI.copyAnswer": "复制回答",
  "agentServiceUI.answerCopied": "已复制",
  "agentServiceUI.answerCopyFailed": "复制失败，请选择文字后复制",
  "agentServiceUI.supplyDemandCardExpand": "展开货物资料",
  "agentServiceUI.supplyDemandCardCollapse": "收起货物资料",
  "agentServiceUI.supplyDemandCardToggleHint":
    "双击卡片可展开或收起货物资料",
  "agentServiceUI.supplyDemandCardUnavailable":
    "货物资料暂不可用，请重新打开此信息",
  "agentServiceUI.supplyDemandField.goodsType": "芯片类型",
  "agentServiceUI.supplyDemandScene": "供需信息",
  "agentServiceUI.supplyDemandCardDetails": "查看本次货物资料",
  "agentServiceUI.supplyDemandSupply": "供应",
  "agentServiceUI.supplyDemandDemand": "求购",
  "agentServiceUI.supplyDemandField.infoNumber": "信息编号",
  "agentServiceUI.supplyDemandField.clueType": "供需类型",
  "agentServiceUI.supplyDemandField.partNumber": "产品料号",
  "agentServiceUI.supplyDemandField.goodsName": "产品名称",
  "agentServiceUI.supplyDemandField.goodsTitle": "产品标题",
  "agentServiceUI.supplyDemandField.goodsBrand": "产品品牌",
  "agentServiceUI.supplyDemandField.goodsPrice": "产品单价",
  "agentServiceUI.supplyDemandField.goodsPriceUnit": "币种",
  "agentServiceUI.supplyDemandField.goodsQuantity": "产品数量",
  "agentServiceUI.supplyDemandField.goodsUnit": "数量单位",
  "agentServiceUI.supplyDemandField.manufactureDate": "货物批次",
  "agentServiceUI.supplyDemandField.usageScenario": "货物情况",
  "agentServiceUI.supplyDemandField.deliveryAddress": "货源所在地",
  "agentServiceUI.supplyDemandField.goodsCategoryName": "产品分类",
  "agentServiceUI.supplyDemandField.categoryAttributes": "分类属性",
  "agentServiceUI.supplyDemandField.goodsImage": "图片",
  "agentServiceUI.supplyDemandField.pictures": "图片列表",
  "agentServiceUI.supplyDemandField.specificationUrl": "规格书",
  "agentServiceUI.supplyDemandField.originCertificate": "原产地证明",
  "agentServiceUI.supplyDemandField.manufacturer": "厂家",
  "agentServiceUI.supplyDemandField.weight": "重量",
  "agentServiceUI.supplyDemandField.length": "长",
  "agentServiceUI.supplyDemandField.width": "宽",
  "agentServiceUI.supplyDemandField.height": "高",
  "agentServiceUI.supplyDemandField.goodsBuyMinQty": "起订量",
  "agentServiceUI.supplyDemandField.substitutes": "替代",
  "agentServiceUI.supplyDemandField.applications": "应用",
  "agentServiceUI.supplyDemandField.goodsPeriod": "有效期",
  "agentServiceUI.supplyDemandField.deliveryPeriod": "交货天数",
  "agentServiceUI.supplyDemandField.traderCompany": "货主公司",
  "agentServiceUI.supplyDemandField.remark": "备注",
  "agentServiceUI.supplyDemandField.productType": "产品类型",
  "agentServiceUI.supplyDemandField.capacity": "容量",
  "agentServiceUI.supplyDemandField.architecture": "架构",
  "agentServiceUI.supplyDemandField.speed": "速率",
  "agentServiceUI.supplyDemandField.ball": "球位",
  "agentServiceUI.moveGrip": "移动聊天小窗，支持拖动与方向键",
  "agentServiceUI.resizeHandle":
    "调节聊天窗口大小（{direction}），支持方向键",
  "agentServiceUI.headerGrip": "聊天标题栏，可拖动或使用方向键移动窗口",
  "agentServiceUI.online": "在线",
  "agentServiceUI.offline": "离线",
  "agentServiceUI.closeChat": "关闭聊天",
  "agentServiceUI.dockLeft": "收纳会话到左侧",
  "agentServiceUI.dockRight": "收纳会话到右侧",
  "agentServiceUI.restoreChat": "展开客服会话，可拖动或使用方向键移动悬浮球",
  "agentServiceUI.onlineSupport": "在线客服",
  "agentServiceUI.chatDialog": "客服聊天",
  "agentServiceUI.messageInput": "聊天消息",
  "agentServiceUI.sendMessage": "发送消息",
  "agentServiceUI.send": "发送",
  "agentServiceUI.composerPlaceholder": "输入消息，按 Enter 发送",
  "agentServiceUI.handoffRequested": "客户请求真人服务",
  "agentServiceUI.handoffHint": "接受后由您直接回复；拒绝则恢复 Agent。",
  "agentServiceUI.rejectHandoff": "拒绝接管",
  "agentServiceUI.acceptHandoff": "接管会话",
  "agentServiceUI.generalTitle": "XSOU 客服",
  "agentServiceUI.generalDialog": "总客服",
  "agentServiceUI.connectingSupport": "正在连接客服",
  "agentServiceUI.reload": "重新加载",
  "agentServiceUI.generalEmpty": "采购询价、平台使用、售后与企业认证",
  "agentServiceUI.connecting": "正在连接",
  "agentServiceUI.loginRequired": "请先登录后使用客服。",
  "agentServiceUI.loginIdentityMissing":
    "未能获取登录身份，请重新登录后使用客服。",
  "agentServiceUI.realtimePolling": "实时连接暂不可用，正在定时补读消息。",
  "agentServiceUI.requestFailed": "客服请求失败，请重试。",
  "agentServiceUI.orderDialog": "订单客服",
  "agentServiceUI.creatingConversation": "正在建立客服会话",
  "agentServiceUI.orderScene": "订单 {orderNum}",
  "agentServiceUI.waitingForStaff": "等待业务员接管",
  "agentServiceUI.cannotSend": "当前状态不能发送消息",
  "agentServiceUI.loadFailed": "客服会话加载失败",
  "agentServiceUI.realtimeUnavailable":
    "实时连接暂时不可用，仍可继续收发消息",
  "agentServiceUI.recoveryReadFailed": "实时恢复后的消息补读失败",
  "agentServiceUI.sendFailed": "消息发送失败",
  "agentServiceUI.retryFailed": "消息重试失败",
  "agentServiceUI.controlUpdateFailed": "会话状态更新失败",
  "agentServiceUI.conversationLanguage": "对话语言",
  "agentServiceUI.toggleTranslationMode": "切换单语或双语展示",
  "agentServiceUI.singleMode": "单语",
  "agentServiceUI.bilingualMode": "双语",
  "agentServiceUI.staffTranslationLanguage": "接待译文：简体中文",
  "agentServiceUI.selectConversationLanguage": "选择对话语言",
  "agentServiceUI.customerLanguage": "客户语言",
  "agentServiceUI.customerLanguageWith": "客户：{language}",
  "agentServiceUI.closeLanguageList": "关闭语言列表",
  "agentServiceUI.conversationLanguageList": "对话语言列表",
  "agentServiceUI.retry": "重试",
  "agentServiceUI.language": "语言",
  "agentServiceUI.returnToReadPosition":
    "返回上次阅读位置，期间有{count}条新消息",
  "agentServiceUI.newMessageCount": "{count}条新消息",
  "agentServiceUI.loading": "加载中",
  "agentServiceUI.viewOlderMessages": "查看更早消息",
  "agentServiceUI.orderEmpty": "可以直接询问库存、交期、MOQ或商品信息",
  "agentServiceUI.translating": "翻译中",
  "agentServiceUI.translationUnavailable": "译文暂不可用",
  "agentServiceUI.aiReply": "AI回复",
  "agentServiceUI.sending": "发送中",
  "agentServiceUI.sendFailedRetry": "发送失败，点击重试",
  "agentServiceUI.aiResponding": "{name}正在回复",
  "agentServiceUI.statusTemporarilyUnavailable":
    "回复状态暂不可用，正在继续等待…",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "messageCenter.messagesFailed": "消息加载失败",
  "messageCenter.sendFailed": "发送失败，请重试",
  "messageCenter.searchContacts": "搜索联系人",
  "messageCenter.loadingConversations": "加载会话中...",
  "messageCenter.conversationsFailed": "会话加载失败",
  "messageCenter.noConversations": "暂无会话",
  "messageCenter.loadingMessages": "加载消息中...",
  "messageCenter.noMessages": "暂无消息",
  "messageCenter.enterMessage": "输入消息",
});

// PC界面显示文案；不改动业务原值。
export const desktopMessageCenter = Object.freeze({
  "messageCenter.search": "搜索",
  "messageCenter.generalSupport": "总客服",
  "messageCenter.orderSupport": "订单客服",
  "messageCenter.aiEnabled": "已启用",
  "messageCenter.aiDisabled": "未启用",
  "messageCenter.aiAssistantLabel": "{name}的聊天助手{status}",
  "messageCenter.forgetLabel": "忘记与{name}相关的Agent咨询记忆",
  "messageCenter.deleteLabel": "删除与{name}的完整会话",
  "messageCenter.processing": "处理中",
  "messageCenter.forget": "忘记",
  "messageCenter.deleting": "删除中",
  "messageCenter.delete": "删除",
  "messageCenter.cancel": "取消",
  "messageCenter.image": "图片",
  "messageCenter.file": "文件",
  "messageCenter.composerPlaceholder":
    "输入消息... (Enter 发送，Shift+Enter 换行)",
  "messageCenter.keyboardHint": "Enter 发送，Shift+Enter 换行",
  "messageCenter.chooseConversation": "选择左侧会话开始聊天",
  "messageCenter.unavailable": "会话不可用",
  "messageCenter.forgetTitle": "忘记咨询记忆",
  "messageCenter.forgetConfirm":
    "只删除Agent形成的咨询记忆，聊天记录仍保留。后续Agent不会再引用本次咨询，确定继续吗？",
  "messageCenter.confirmForget": "确认遗忘",
  "messageCenter.forgotten": "本次咨询记忆已遗忘，聊天记录仍保留",
  "messageCenter.forgetFailed": "咨询记忆遗忘失败",
  "messageCenter.deleteTitle": "删除会话",
  "messageCenter.deleteConfirm":
    "确定删除与“{name}”的完整会话吗？聊天记录将从双方消息中心删除；已形成的咨询备忘会转为只读历史，不再更新。如需同时清除记忆，请先使用“忘记咨询记忆”。",
  "messageCenter.deleted": "会话已删除",
  "messageCenter.deleteFailed": "会话删除失败",
  "messageCenter.authMissing": "授权参数缺失，请重新授权",
  "messageCenter.wecomLoginFailed": "企业微信登录失败",
  "messageCenter.wecomLoginError": "企业微信登录异常",
  "messageCenter.unknownUser": "未知用户",
  "messageCenter.syncFailed": "客服消息同步失败，请稍后重试。",
  "messageCenter.aiUpdateFailed": "AI代聊状态更新失败",
  "messageCenter.yesterday": "昨天 {time}",
  "messageCenter.justNow": "刚刚",
  "messageCenter.minutesAgo": "{count}分钟前",
  "messageCenter.hoursAgo": "{count}小时前",
  "messageCenter.operationFailed": "订单客服操作失败",
  "messageCenter.conversationMissing": "会话已不存在，请重新打开客服窗口。",
  "messageCenter.conversationNotReady": "客服会话尚未建立",
  "messageCenter.sendingBusy": "消息正在发送，请稍候",
  "messageCenter.controlBusy": "客服控制状态正在更新，请稍候",
  "messageCenter.emptyMessage": "消息不能为空",
  "messageCenter.cannotSend": "当前会话状态不能发送消息",
  "messageCenter.controlUpdateFailed": "客服控制状态更新失败",
  "messageCenter.networkBusy": "网络繁忙请稍后再试",
});

export const messages = Object.freeze({
  ...desktopMessageCenter,
  ...mobileWorkflow,
  ...ui,
});
